import { createSelector } from '@reduxjs/toolkit';
import { initialState } from './reducer';

const selectEkycInfo = state => state.ekyc || initialState;

const makeSelectAadhaarNo = () =>
  createSelector(
    selectEkycInfo,
    substate => substate.form.aadhaarNo,
  );

const makeSelectOtpCode = () =>
  createSelector(
    selectEkycInfo,
    substate => substate.form.otpCode,
  );

const makeSelectErrorCode = () =>
  createSelector(
    selectEkycInfo,
    substate => substate.errorCode,
  );

const makeSelectKycId = () =>
  createSelector(
    selectEkycInfo,
    substate => substate.kycId,
  );

const makeSelectPublicKey = () =>
  createSelector(
    selectEkycInfo,
    substate => substate.publicKey,
  );

export {
  selectEkycInfo,
  makeSelectAadhaarNo,
  makeSelectOtpCode,
  makeSelectErrorCode,
  makeSelectKycId,
  makeSelectPublicKey,
};
